/* ==========================================================================
   GSAP ANIMATIONS (PHASE 3)
   ========================================================================== */

document.addEventListener("DOMContentLoaded", (event) => {
    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger);

    /* Manifesto Scrub Animation */
    const manifestoText = document.getElementById('manifesto-text');
    if (manifestoText) {
        gsap.to(manifestoText, {
            color: 'rgba(255,255,255,1)', // Highlight text
            scrollTrigger: {
                trigger: manifestoText,
                start: "top 80%",
                end: "bottom 50%",
                scrub: true
            }
        });
    }

    // 4. MAGNETIC BUTTONS (Mouse follow effect)
    const magneticBtns = document.querySelectorAll(".magnetic-btn");
    
    magneticBtns.forEach(btn => {
        btn.addEventListener("mousemove", (e) => {
            const rect = btn.getBoundingClientRect();
            const x = e.clientX - rect.left - rect.width / 2;
            const y = e.clientY - rect.top - rect.height / 2;
            
            gsap.to(btn, {
                x: x * 0.3,
                y: y * 0.3,
                duration: 0.4,
                ease: "power2.out"
            });
        });
        
        btn.addEventListener("mouseleave", () => {
            gsap.to(btn, {
                x: 0,
                y: 0,
                duration: 0.7,
                ease: "elastic.out(1, 0.3)"
            });
        });
    });

    // 2. Immersive Hero Reveal Animations
    const tl = gsap.timeline();
    
    // Header comes down
    tl.fromTo(".site-header", 
        { y: -100, opacity: 0 }, 
        { y: 0, opacity: 1, duration: 1, ease: "power3.out" }
    )
    // Massive text layers animate in perfect sync (no staggering spans to prevent offset)
    // We use xPercent and yPercent to preserve the CSS centering (-50%, -50%)
    .fromTo(".hero-massive-text", 
        { scale: 0.9, opacity: 0, xPercent: -50, yPercent: -50, y: 30 }, 
        { scale: 1, opacity: 1, xPercent: -50, yPercent: -50, y: 0, duration: 1.2, ease: "power4.out" },
        "-=0.5"
    )
    // Logo fades and gently floats up (Apple style, no sudden jumps)
    .fromTo(".js-hero-logo",
        { opacity: 0, scale: 0.95, y: 30 },
        { 
            opacity: 1, scale: 1, y: 0, duration: 2, ease: "expo.out",
            onComplete: () => {
                // Ambient idle floating
                gsap.to(".js-hero-logo", {
                    y: -15,
                    rotationZ: 2,
                    duration: 4,
                    ease: "sine.inOut",
                    yoyo: true,
                    repeat: -1
                });
            }
        },
        "-=1.0"
    )
    // Bottom bar fades in
    .fromTo(".js-hero-bottom",
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.5, ease: "power2.out" },
        "-=1.5"
    );

    // 3. Immersive 3D Parallax on Mousemove
    const heroContainer = document.querySelector(".hero-immersive-container");
    const heroLogoWrap = document.querySelector(".js-hero-graphic");
    const fgText = document.querySelector(".hero-massive-text--fg");
    const bgText = document.querySelector(".hero-massive-text--bg");
    
    if(heroContainer && heroLogoWrap) {
        window.addEventListener("mousemove", (e) => {
            const x = (e.clientX / window.innerWidth - 0.5);
            const y = (e.clientY / window.innerHeight - 0.5);
            
            // Rotate the logo wrap based on mouse position to create depth
            // Text remains perfectly aligned to maintain legibility and elegance
            gsap.to(heroLogoWrap, {
                rotationY: x * 25,
                rotationX: -y * 25,
                x: x * -40,
                y: y * -40,
                ease: "power2.out",
                duration: 1
            });
        });
    }

    // 4. Scroll Reveal Text (Intro)
    const splitTexts = document.querySelectorAll(".js-split-text");
    splitTexts.forEach(text => {
        // Simple manual split text by words (since we don't have SplitText plugin)
        const words = text.innerText.split(" ");
        text.innerHTML = "";
        words.forEach(word => {
            const span = document.createElement("span");
            span.style.display = "inline-block";
            span.style.overflow = "hidden";
            span.style.paddingRight = "10px";
            
            const innerSpan = document.createElement("span");
            innerSpan.style.display = "inline-block";
            innerSpan.innerText = word;
            
            span.appendChild(innerSpan);
            text.appendChild(span);
        });

        gsap.fromTo(text.querySelectorAll("span > span"),
            { y: "100%", rotation: 5, opacity: 0 },
            {
                y: "0%", rotation: 0, opacity: 1,
                duration: 1, stagger: 0.05, ease: "power4.out",
                scrollTrigger: {
                    trigger: text,
                    start: "top 80%",
                }
            }
        );
    });

    // 5. Scroll Reveal Apple Style (Cards & Text)
    const scrollReveals = document.querySelectorAll(".js-scroll-reveal, .js-product-reveal");
    scrollReveals.forEach(el => {
        gsap.fromTo(el, 
            { y: 40, opacity: 0 },
            { 
                y: 0, opacity: 1, 
                duration: 1.2, 
                ease: "expo.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 85%",
                }
            }
        );
    });

    // 5.5 Dynamic Scrub Animations (Deep Dives)
    // Texts slide in softly and stick slightly, responding to scroll
    const dynamicTexts = document.querySelectorAll(".js-dynamic-text");
    dynamicTexts.forEach(text => {
        gsap.fromTo(text,
            { y: 80, opacity: 0.2 },
            {
                y: 0, opacity: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: text,
                    start: "top 95%",
                    end: "top 40%",
                    scrub: 1 // smooth scrubbing
                }
            }
        );
    });

    const dynamicImageContainers = document.querySelectorAll(".js-dynamic-image");
    dynamicImageContainers.forEach(imgWrap => {
        gsap.fromTo(imgWrap,
            { y: 100, scale: 0.9, opacity: 0.5 },
            {
                y: 0, scale: 1, opacity: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: imgWrap,
                    start: "top 100%",
                    end: "top 50%",
                    scrub: 1.5
                }
            }
        );
    });

    // Category Cards with Stagger and Image Parallax
    const categoryCards = document.querySelectorAll(".category-card");
    categoryCards.forEach((card, index) => {
        // Card Entrance
        gsap.fromTo(card,
            { opacity: 0, y: 50, scale: 0.98 },
            { 
                opacity: 1, y: 0, scale: 1,
                duration: 1.2, 
                ease: "expo.out",
                scrollTrigger: {
                    trigger: card,
                    start: "top 90%",
                }
            }
        );

        // Internal Image Parallax
        const img = card.querySelector(".category-card__image");
        if(img) {
            gsap.fromTo(img, 
                { y: "-5%", scale: 1.05 },
                {
                    y: "5%",
                    ease: "none",
                    scrollTrigger: {
                        trigger: card,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true
                    }
                }
            );
        }
    });

    // 6. Deep Dive Image Parallax (Apple style window effect)
    const deepDiveImages = document.querySelectorAll(".stampa-image img, .thesis-image img, .merch-image img");
    deepDiveImages.forEach((img) => {
        gsap.fromTo(img, 
            { y: "-10%", scale: 1.1 },
            {
                y: "10%",
                ease: "none",
                scrollTrigger: {
                    trigger: img.parentElement,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            }
        );
    });

    // 7. Background Blobs Parallax
    gsap.utils.toArray(".hero-bg-blob").forEach(blob => {
        const speed = blob.getAttribute("data-speed");
        gsap.to(blob, {
            y: (i, el) => (1 - parseFloat(speed)) * ScrollTrigger.maxScroll(window) * 0.5,
            ease: "none",
            scrollTrigger: {
                trigger: ".hero-section",
                start: "top top",
                end: "bottom top",
                scrub: 1
            }
        });
    });

    // Section Titles Dynamic Reveal
    const titleReveals = gsap.utils.toArray('.js-title-reveal');
    titleReveals.forEach(title => {
        gsap.from(title, {
            scrollTrigger: {
                trigger: title,
                start: 'top 85%',
            },
            y: 40,
            opacity: 0,
            rotationX: -20,
            transformOrigin: '0% 50% -50',
            duration: 1,
            ease: 'back.out(1.5)'
        });
    });

    // Apple Scroll Sequence (Merchandising)
    const appleSection = document.querySelector(".js-apple-section");
    if (appleSection) {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: appleSection,
                start: "top top",
                end: window.innerWidth < 768 ? "+=1000" : "+=2000",
                scrub: 1,
                pin: true,
                anticipatePin: 1
            }
        });

        // 1. Text splits apart
        tl.to(".js-apple-text-l", { x: window.innerWidth < 768 ? "-80vw" : "-60vw", duration: 1 }, 0)
          .to(".js-apple-text-r", { x: window.innerWidth < 768 ? "80vw" : "60vw", duration: 1 }, 0);

                // 2a. All products fly up from bottom and stack in the center
        tl.to([".js-merch-center-pen", ".js-merch-notebook", ".js-merch-cap"], {
            top: "50%",
            yPercent: -50,
            duration: 0.8,
            ease: "power2.out"
        }, 0.1);

        // 2b. The FAN OUT effect (they spread and scale up while pen tumbles)
                tl.to(".js-merch-center-pen", {
            rotation: 720,
            scale: window.innerWidth < 768 ? 0.8 : 1.8,
            duration: 1.2,
            ease: "power2.inOut"
        }, 0.8);

                tl.to(".js-merch-notebook", {
            x: window.innerWidth < 768 ? -40 : -360,
            yPercent: window.innerWidth < 768 ? -80 : -40,
            rotation: -15,
            scale: window.innerWidth < 768 ? 0.6 : 1.5,
            duration: 1.2,
            ease: "power2.inOut"
        }, 0.8);

                tl.to(".js-merch-cap", {
            x: window.innerWidth < 768 ? 40 : 360,
            yPercent: window.innerWidth < 768 ? -20 : -60,
            rotation: 20,
            scale: window.innerWidth < 768 ? 0.6 : 1.6,
            duration: 1.2,
            ease: "power2.inOut"
        }, 0.8);

        

        

        // 3. Subtitle fades in at the end
        tl.to(".js-apple-subtitle", {
            y: 0,
            opacity: 1,
            duration: 0.5
        }, 0.6);
    }




                // --- Chat Hologram Animation ---
    const chatContainer = document.querySelector('.chat-to-real-container');
    if (chatContainer) {
        const phoneMockup = chatContainer.querySelector('.mockup-phone');
        const bubbles = chatContainer.querySelectorAll('.chat-bubble:not(.js-final-reply)');
        const finalReply = chatContainer.querySelector('.js-final-reply');
        const chatBody = chatContainer.querySelector('.chat-body');
        const objectReveal = chatContainer.querySelector('.real-object-reveal');
        
        const chatTl = gsap.timeline({
            repeat: -1, // Infinite loop
            repeatDelay: 3, 
            scrollTrigger: {
                trigger: chatContainer,
                start: "top 75%",
            }
        });

        // 1. Reset everything
        chatTl.set(bubbles, { opacity: 0, y: 20 })
              .set(finalReply, { opacity: 0, y: 20 })
              .set(chatBody, { y: 0 })
              .set(objectReveal, { opacity: 0, scale: 0.1, x: -350, y: 0 }) // Starts deep INSIDE/BEHIND the phone (which is ~350px left)
              .set(phoneMockup, { x: 0, y: 0 }); // Reset phone position

        // 2. Chat conversation starts
        chatTl.to(bubbles, { 
            opacity: 1, 
            y: 0, 
            stagger: 1.2, 
            duration: 0.4, 
            ease: "back.out(1.5)"
        });

        // 3. Scroll up in TWO steps to keep up with messages
        chatTl.to(chatBody, { y: -80, duration: 1, ease: "power2.inOut" }, 2.5); 
        chatTl.to(chatBody, { y: -220, duration: 1.5, ease: "power2.inOut" }, 5.0);

        // 4. Phone Vibrates AND Object pops OUT of the phone
        const popTime = "-=0.2";
        
        // Vibrate phone
        chatTl.to(phoneMockup, {
            x: "random(-5, 5, 1)",
            y: "random(-5, 5, 1)",
            duration: 0.1,
            repeat: 7,
            yoyo: true,
            ease: "none"
        }, popTime);
        
        // Reset phone position exactly after vibration
        chatTl.to(phoneMockup, { x: 0, y: 0, duration: 0.1 }, popTime + "+0.7");

        // Object flies out from the phone (-350x) to its final resting spot (0x)
        chatTl.to(objectReveal, {
            opacity: 1,
            scale: 1.15,
            x: -80, 
            y: 0, 
            rotation: "random(-10, 10)", // Slight playful rotation on exit
            duration: 1.2,
            ease: "elastic.out(1, 0.6)"
        }, popTime); 

        // Return object rotation to 0 for a clean resting state
        chatTl.to(objectReveal, { rotation: 0, duration: 0.5, ease: "power1.out" }, ">-0.5");

        // 5. Scroll slightly more to make room for final reply
        chatTl.to(chatBody, { y: -270, duration: 0.5, ease: "power2.inOut" }, ">-0.5");

        // 6. Final reply from customer
        chatTl.to(finalReply, {
            opacity: 1,
            y: 0,
            duration: 0.4,
            ease: "back.out(1.5)"
        }, "<"); 
        
        // 7. Pause
        chatTl.to({}, { duration: 3 });
    }
});